// Required modules
import NavBar from "components/Admin/NavBar/NavBar";
import GenericTable from "components/Tables/GenericTable";
import Form from "components/Forms/Form.jsx";

// Config admin class
import ConfigAdmin from "./ConfigAdmin.js";

// Hooks
import { useEffect, useState } from "react";
import useForm from "hooks/useForm.jsx";

// Necessary data
import {
  headersTableLibraryLine,
  keyValuesTableLibraryLine,
  initialValuesFormLibraryLine,
} from "./dataConfigAdmin";

// Styles
import {
  ConfigAdminContainer,
  ColumnAdminConfig,
  RowAdminConfig,
  CreateNewRegionButton,
  SeparatorWithText,
  InformationShare,
  IconAdminConfigChangeColum,
} from "./configAdminStyles";
import { IoMdAdd } from "react-icons/io";
import { BsChevronCompactUp } from "react-icons/bs";
import { ContainerForm } from "components/Forms/FormStyles";
import OpenDialog from "components/Dialogs/OpenDialog.jsx";

// Button to render before of title in form
const ButtonSeeInitalView = ({ click }) => {
  const some = () => {
    click();
  };

  return (
    <IconAdminConfigChangeColum onClick={some}>
      <BsChevronCompactUp />
    </IconAdminConfigChangeColum>
  );
};

export default function LibraryLine() {
  // Config admin object
  const [configAdmin, setConfigAdmin] = useState(null);
  const [seeForm, setSeeForm] = useState(false);

  // Dialog
  const [openDialog, setOpenDialog] = useState(false);
  const [contentDialog, setContentDialog] = useState({
    title: "Error",
    description: "You don't have the credentials",
    disagree: "Accept",
  });

  const executeDialog = () => {
    setOpenDialog(() => false);
  };

  // Everything related to the form
  let [form, methodsForm] = useForm(initialValuesFormLibraryLine);
  const { handleChangeForm, changeFormForSpecificValues, clearField } =
    methodsForm;
  const [buttonsForm, setButtonsForm] = useState([]);

  // Necessary functions in the config admin of the form
  if (configAdmin) {
    configAdmin.setChangeFormForSpecificValues(changeFormForSpecificValues);
    configAdmin.setOnChangeFields(handleChangeForm);
  }

  // Rows of table
  const [libreriesRows, setLibreriesRows] = useState([]);

  // Click  on type element ghg into table
  const handleClickLibrary = (id) => {
    configAdmin.handlerClickIntoTable(id);
  };

  // Create object to config admin and set it
  useEffect(() => {
    const configAdmin = new ConfigAdmin();
    configAdmin.setHeadersTable(headersTableLibraryLine);
    configAdmin.setKeyValuesTable(keyValuesTableLibraryLine);
    configAdmin.setSetRows(setLibreriesRows);
    configAdmin.setSetButtons(setButtonsForm);
    configAdmin.setSetSeeForm(setSeeForm);
    configAdmin?.setEndpoint(`api/v1/line-libraries`);
    configAdmin?.setDialog(setOpenDialog, setContentDialog);
    setConfigAdmin(configAdmin);
    setButtonsForm([configAdmin.buttonCreate]);
  }, []);

  // Set library in config admin
  useEffect(() => {
    configAdmin?.setEndpointFetch(`api/v1/line-libraries`);
    configAdmin?.fetchData();
  }, [configAdmin]);

  // Field forms of config admin
  useEffect(() => {
    configAdmin && configAdmin.setFieldForm(form);
  }, [form, configAdmin]);

  // Clear fields form
  useEffect(() => {
    configAdmin && configAdmin.setClearFields(clearField);
  }, [clearField, configAdmin]);

  return (
    <div>
      <NavBar linkLogo={"admin"} />
      <OpenDialog
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
        execute={executeDialog}
        content={contentDialog}
      />
      <ConfigAdminContainer>
        <RowAdminConfig>
          <ColumnAdminConfig>
            {configAdmin && (
              <GenericTable
                headers={configAdmin.getHeadersTable()}
                rows={libreriesRows}
                keyValues={configAdmin.getKeyValuesTable()}
                handlerClick={handleClickLibrary}
                style={{
                  width: 100,
                }}
                state={true}
              />
            )}
          </ColumnAdminConfig>
          <ColumnAdminConfig>
            <ContainerForm see={seeForm}>
              <Form
                form={form}
                handleChange={handleChangeForm}
                handleRows={handleClickLibrary}
                buttons={buttonsForm}
                renderBeforeTitle={[
                  <ButtonSeeInitalView
                    click={() => configAdmin.toggleForm()}
                  />,
                ]}
                title={"Create a new Digital Twin Library"}
              />
            </ContainerForm>

            {!seeForm && (
              <>
                <CreateNewRegionButton>
                  Create a new Digital Twin Library
                  <button onClick={() => configAdmin.toggleForm()}>
                    <span>
                      <IoMdAdd />
                    </span>
                    New Type Library
                  </button>
                </CreateNewRegionButton>

                <SeparatorWithText>
                  <span className="left"></span>
                  Or
                  <span className="right"></span>
                </SeparatorWithText>

                <InformationShare>
                  <div className="head">Edit Existing Digital Twin Library</div>
                  <div className="body">
                    To Edit Click on Existing Digital Twin Library ID
                  </div>
                </InformationShare>
              </>
            )}
          </ColumnAdminConfig>
        </RowAdminConfig>
      </ConfigAdminContainer>
    </div>
  );
}
